import React, { useEffect, useState } from 'react'
import { Card, CardContent } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from 'src/utils/Themes/colors'
import { get } from 'lodash'
import PieChart from 'src/components/common/charts/PieChart'
import formatToINR from 'src/utils/commonMethods/formatToINR'

const CHART_HEIGHT = 230
const CHART_COLORS = ['#FEBA41', '#73CFEE', '#9271BE', '#EF669B']

const TotalVehicles = ({ total, otherData, chartData }) => {
  const classes = useStyles()
  const [totalPremium, setTotalPremium] = useState(0)
  const [categories, setCategories] = useState(['', '', ''])
  const [series, setSeries] = useState([0, 0, 0, 0])

  const computeTotalPremium = () => {
    const premiumData = get(otherData, '0.premium', 0)
    setTotalPremium(formatToINR(premiumData))
  }

  const computeChartData = () => {
    const CATEGORIES = chartData?.map((e) => e?.insuranceSubType)
    const SERIES = chartData?.map((d) => d?.count)
    setSeries(SERIES)
    setCategories(CATEGORIES)
  }

  useEffect(() => {
    if (otherData) {
      computeTotalPremium()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otherData])

  useEffect(() => {
    if (chartData) {
      computeChartData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartData])

  return (
    <>
      <div className={classes.root}>
        <Card className={classes.cardContainer}>
          <CardContent>
            <h2 className={classes.title}>Total No. of Vehicles: {total}</h2>
            <h3 className={classes.subTitle}>
              Total Premium:&nbsp;
              <span className={classes.subTitleHelper}>{totalPremium}</span>
            </h3>

            <PieChart
              categories={categories}
              // otherCategories={otherCategories}
              series={series}
              height={CHART_HEIGHT}
              colors={CHART_COLORS}
            />
          </CardContent>
        </Card>
      </div>
    </>
  )
}

export default TotalVehicles

const useStyles = makeStyles({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    borderRadius: '10px',
    textAlign: 'center',
    // boxShadow: "4px 7px 15px rgba(0, 0, 0, 0.1)",
  },
  title: {
    fontSize: '18px',
    lineHeight: '22px',
    marginTop: '0px',
    padding: '0px 18px',
    color: COLORS.GREY,
    fontWeight: '600',
  },
  cardContainer: {
    borderRadius: '10px',
    padding: '6px',
    overflow: 'visible',
  },
  supportText: {
    color: COLORS.GREY_12,
    marginTop: 0,
    fontSize: 15,
  },
  subTitle: {
    fontSize: '15px',
    lineHeight: '18px',
    marginTop: '0px',
    color: 'rgba(51, 51, 51, 0.5)',
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  subTitleHelper: {
    fontSize: '22px',
    color: COLORS.GREY,
    fontWeight: '600',
  },
})
